import classNames from 'classnames';
import Link from 'components/Link';
import {Tooltip} from 'components/Tooltip';
import {Typography} from 'components/Typography';
import style from './style.module.scss';
import React, {FC, useMemo, useState} from 'react';
import Icon from 'components/Icon';
import {NEXT_PUBLIC_MASTER_HOST} from 'core/helpers/env';

export const BusinessPopup: FC = () => {
    const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);
    const renderBusinessOverlay = useMemo(() => {
        return (
            <ul className={style.forBusinessList}>
                <Link
                    className={classNames(style.forBusinessItem, 'business-navigation__link')}
                    data-autotest-target={'header-links-b2b'}
                    data-autotest-target-id={'header-links-b2b-1'}
                    href={`${NEXT_PUBLIC_MASTER_HOST}/corp/`}
                    target={'_blank'}
                    theme={'black'}
                >
                    <Typography element={'div'} variant={'h5-medium'}>
                        Корпоративным клиентам
                    </Typography>
                </Link>
                <Link
                    className={classNames(style.forBusinessItem, 'business-navigation__link')}
                    data-autotest-target={'header-links-b2b'}
                    data-autotest-target-id={'header-links-b2b-2'}
                    href={'https://b2b.simple.ru/business/'}
                    target={'_blank'}
                    theme={'black'}
                >
                    <Typography element={'div'} variant={'h5-medium'}>
                        Ресторанам, магазинам, дистрибьюторам
                    </Typography>
                </Link>
                <Link
                    className={classNames(style.forBusinessItem, 'business-navigation__link')}
                    data-autotest-target={'header-links-b2b'}
                    data-autotest-target-id={'header-links-b2b-3'}
                    href={'https://simple.ru/services/franchise/'}
                    target={'_blank'}
                    theme={'black'}
                >
                    <Typography element={'div'} variant={'h5-medium'}>
                        Франшиза винных бутиков
                    </Typography>
                </Link>
            </ul>
        );
    }, []);

    return (
        <Tooltip
            className={style.tooltip}
            openOnClick={true}
            overlay={renderBusinessOverlay}
            place={'bottom-start'}
            isOpen={isTooltipOpen}
            setIsOpen={setIsTooltipOpen}
        >
            <li className={style.businessList} onClick={() => setIsTooltipOpen((isOpen) => !isOpen)}>
                <button
                    className={'business-navigation__toggler dropdown__toggler'}
                    data-autotest-target={'header-links'}
                    data-autotest-target-id={'header-links-b2b'}
                    aria-expanded={isTooltipOpen}
                    aria-haspopup={'menu'}
                >
                    <Typography className={style.headerDropDown} element={'div'} variant={'label-14-r'}>
                        Для бизнеса
                        <div
                            className={classNames(style.tooltipArrow, {
                                [style.tooltipArrowUp]: isTooltipOpen,
                            })}
                        >
                            <Icon icon={'down'} />
                        </div>
                    </Typography>
                </button>
                <div className={style.tooltip} role={'menu'} aria-hidden={'true'} hidden={true}>
                    {renderBusinessOverlay}
                </div>
            </li>
        </Tooltip>
    );
};
